import { cn } from '../../utils';

export default function Layout(
  props: React.PropsWithChildren<{
    contentContainerClassName?: string;
    backdropClassName?: string;
  }>,
) {
  return (
    <>
      <div
        className={cn('absolute top-0 h-full w-full bg-[#1A1A1A]/70', props.backdropClassName)}
      ></div>
      <div
        className={cn(
          'absolute top-0 h-full w-full backdrop-blur-lg overflow-x-hidden overflow-y-auto',
          props.contentContainerClassName,
        )}
      >
        {props.children}
      </div>
    </>
  );
}
